import { sendAnalyticsEventAsync } from './analytics';

export const logAnalyticsEvent = (evtType, evtParameters) => {
  sendAnalyticsEventAsync(evtType, evtParameters);
};
